import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadedCapacityFileLog } from 'api/types';
import { LoadingDialogComponent, loadingDialogConfig, LoadingDialogInput } from 'components/dialogs/loading-dialog/loading-dialog.component';
import { TranslatePipe, TranslationLookup } from 'pipes/translate.pipe';
import { take } from 'rxjs/operators';
import { CapacityService } from 'services/api/capacity.service';
import { VueToastComponent } from 'vue/components/vue-toast/vue-toast.component';

@Component({
  selector: 'app-capacity-file-menu',
  standalone: false,
  templateUrl: './capacity-file-menu.component.html',
  styleUrl: './capacity-file-menu.component.scss'
})
export class CapacityFileMenuComponent {
  @Input() public elements!: any;
   @Output() messageEvent = new EventEmitter<string>();
    @Output() error = new EventEmitter<string>();
 private translations: TranslationLookup = {};
 

  public toastMessage = '';
   @ViewChild(VueToastComponent) public toast!: VueToastComponent;
  public constructor(
     private translatePipe: TranslatePipe,
      private capacityService: CapacityService,
        private dialog: MatDialog,

  ){}

   public downloadFile(selectedFile: UploadedCapacityFileLog) {
      this.capacityService
        .downloadCapacityFile(selectedFile.id)
        .pipe(take(1))
        .subscribe(
          (data: Blob) => {
            const file = new Blob([data], { type: 'text/csv' });
            const fileURL = URL.createObjectURL(file);
  
            // if you want to open PDF in new tab
            //window.open(fileURL);
            const a = document.createElement('a');
            a.href = fileURL;
            // a.target = '_blank';
            a.download = `${selectedFile.filename}`;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              this.toastMessage = this.translations['message.file.downloaded'];
              this.toast.heading = this.translations['title.fileDownload'];
              this.toast.open();
            }, 1500);
          },
          (error: unknown) => {
            
          }
        );
    }

    submitUndoData(event:any,data:any){
      const loader = this.dialog.open<LoadingDialogComponent, LoadingDialogInput>(LoadingDialogComponent, {
            ...loadingDialogConfig,
            data: {
              title: 'title.loading',
              subtitle: 'subtitle.pleaseWait',
            },
          });
      let payload={
        filename : data.filename,
        id : data.id
      }
      this.capacityService.updateUndofile(payload).subscribe((ele:any)=>{
          loader.close();
      this.toastMessage=data.filename
      this.messageEvent.emit(data.filename);
      },(error:any)=>{
      loader.close();
      this.messageEvent.emit(error.message);
      })

    }
}
